/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('databaseSourceEditor', [
  '$rootScope',
  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./database-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {
        scope.$watch('component.split_by_column_name', function (splitByColumnName) {
          if (scope.component.access_mode === 'table') {
            const splitBySet = splitByColumnName.length > 0;
            $rootScope.split_by_column_name_set = splitBySet;
            if (!splitBySet) scope.component.parallel = 1;
          }
        });

        scope.$on('$destroy', function () {
          delete $rootScope.split_by_column_name_set;
        });
      },

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
